import{jsx as t}from"react/jsx-runtime";import{InputField as r}from"@vds-core/inputs";const e=function(e){return t(r,Object.assign({},e))};e.defaultProps={transparentBackground:!1,surface:"light"};export{e as default};
